import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import About from './components/About.vue'
import Dashboard from './components/Dashboard.vue'
import Users from './components/Users.vue'
import AddCook from './components/Cooks/AddCook.vue'
import EditCook from './components/Cooks/EditCook.vue'
import Cooks from './components/Cooks/Cooks.vue'
import ByIngredients from './components/Cooks/ByIngredients.vue'
import Cook from './components/Cooks/Cook.vue'
import MyCooks from './components/Cooks/MyCooks.vue'
import Search from './components/Cooks/Search.vue'
import Favorites from './components/Cooks/Favorites.vue'

import Profile from './components/Auth/Profile.vue'
import Signin from './components/Auth/Signin.vue'
import Signup from './components/Auth/Signup.vue'
import FourOhFour from './components/FourOhFour.vue'
import AuthGuard from './AuthGuard'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      beforeEnter: AuthGuard
    },
    {
      path: '/cooks',
      name: 'Cooks',
      component: Cooks
    },
    {
      path: '/byIngredients',
      name: 'ByIngredients',
      component: ByIngredients
    },
    {
      path: '/favorites',
      name: 'Favorites',
      component: Favorites,
      beforeEnter: AuthGuard
    },
    {
      path: '/mycooks',
      name: 'MyCooks',
      component: MyCooks,
      beforeEnter: AuthGuard
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/cooks/:cookId',
      name: 'Cook',
      component: Cook,
      props: true
    },
    {
      path: '/cook/add',
      name: 'AddCook',
      component: AddCook,
      beforeEnter: AuthGuard
    },
    {
      path: '/cook/edit/:cookId',
      name: 'EditCook',
      component: EditCook,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/*',
      component: FourOhFour
    },
  ]
})
